import {
  type SemanticLegendSettingsWithCategoricalConfig,
  type YAxisValues,
} from '../../types';
import {DEFAULT_SEMANTIC_LEGEND_SETTINGS} from '../SemanticLegendDefaults';
import {parseBucketsFromSemanticLegendSettings} from './parseBuckets';

type SemanticLegendSettingsMutationVars = {
  bucketUpperBounds: number[];
  categories?: string[];
  customColors: string[];
  excludedRunColor: string;
  metricName: string;
  yValue: YAxisValues;
};

export function getMutationVarsFromSettingsWithCategoricalConfig(
  settings: SemanticLegendSettingsWithCategoricalConfig
): SemanticLegendSettingsMutationVars {
  const yAxisValue =
    settings.yAxisValue ?? DEFAULT_SEMANTIC_LEGEND_SETTINGS.yAxisValue;

  const {customColors, bucketUpperBounds} =
    parseBucketsFromSemanticLegendSettings(settings);
  const settingsToUpdate: SemanticLegendSettingsMutationVars = {
    metricName: settings.key || DEFAULT_SEMANTIC_LEGEND_SETTINGS.key,
    yValue: yAxisValue,
    excludedRunColor:
      settings.excludedRunColor ||
      DEFAULT_SEMANTIC_LEGEND_SETTINGS.excludedRunColor,
    categories: settings.selectedCategories,
    customColors: customColors,
    bucketUpperBounds: bucketUpperBounds?.map(bucket => bucket ?? 0) ?? [],
  };

  return settingsToUpdate;
}
